import React, { } from 'react'

import AuthPanel from './AuthPanel'

// Body swapped for the canonical lib-core auth panel (email + Google + phone
// OTP). The old Google/Facebook-button page and its redux selector are
// superseded; the route ('home/welcome/login') is unchanged.
const LoginPage = () => {
  return <AuthPanel />
}

export default LoginPage
